const ConversationPreviewPath = '/conversation/preview';
const UUIDPattern =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export type PreviewLinks = {
  publicPreviewURL: string;
  appDeepLink: string;
};

export function buildPreviewLinks({
  conversationID,
  origin = window.location.origin,
}: {
  conversationID: string;
  origin?: string;
}): PreviewLinks {
  const publicPreviewURL = new URL(ConversationPreviewPath, origin);
  publicPreviewURL.searchParams.set('conversationID', conversationID);

  return {
    publicPreviewURL: publicPreviewURL.toString(),
    appDeepLink: `codify://preview/${conversationID}`,
  };
}

export function isPublicPreviewPath(pathname: string): boolean {
  return pathname === ConversationPreviewPath;
}

export function readPreviewConversationID(search: string): string | null {
  const params = new URLSearchParams(search);
  const conversationID = params.get('conversationID');
  if (conversationID === null || !UUIDPattern.test(conversationID)) {
    return null;
  }

  return conversationID;
}
